export default "__VITE_ASSET__198ae55c__"